export const trapFocus = (event: KeyboardEvent, modal: HTMLElement): void => {
  const isTabPressed = event.key === 'Tab';
  if (!isTabPressed || event.defaultPrevented) {
    return;
  }
  const focusableElements = 'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])';
  const focusableContent = Array.from(modal.querySelectorAll(focusableElements)) as HTMLElement[];
  const filteredFocusableContent = focusableContent.filter(element => element.offsetHeight > 0);

  const firstFocusableElement = filteredFocusableContent[0] as HTMLElement;
  const lastFocusableElement = filteredFocusableContent[filteredFocusableContent.length - 1] as HTMLElement;

  if (event.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      event.preventDefault();
    }
  } else if (document.activeElement === lastFocusableElement) {
    firstFocusableElement.focus();
    event.preventDefault();
  }
};

export const focusTrap = (event: KeyboardEvent, focusableElements: NodeListOf<HTMLElement>, additionalCondition: boolean | undefined): void => {
  const isTabPressed = event.key === 'Tab';
  if (!isTabPressed || event.defaultPrevented || !additionalCondition) {
    return;
  }

  const focusableContent = Array.from(focusableElements) as HTMLElement[];
  const filteredFocusableContent = focusableContent.filter(element => element.offsetHeight > 0);

  const firstFocusableElement = filteredFocusableContent[0] as HTMLElement;
  const lastFocusableElement = filteredFocusableContent[filteredFocusableContent.length - 1] as HTMLElement;

  if (event.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      event.preventDefault();
    }
  } else if (document.activeElement === lastFocusableElement) {
    firstFocusableElement.focus();
    event.preventDefault();
  }
};

export const toggleScrollbarWidthOnBody = (): void => {
  let width = "0";

  if (document.body.classList.contains("menu-is-open") && document.documentElement.scrollHeight > window.innerHeight) {
    width = `${String(getScrollbarWidth())}px`;
  }

  document.body.style.paddingRight = width;
};

export const getScrollbarWidth = (): number => {
  const tmpDiv = document.createElement('div');
  // @ts-expect-error explain
  tmpDiv.style.msOverflowStyle = 'scrollbar';
  tmpDiv.style.visibility = 'hidden';
  tmpDiv.style.overflow = 'scroll';
  document.body.appendChild(tmpDiv);

  const inner = document.createElement('div');
  tmpDiv.appendChild(inner);

  const scrollbarWidth = (tmpDiv.offsetWidth - inner.offsetWidth);
  tmpDiv?.parentNode?.removeChild(tmpDiv);

  return scrollbarWidth;
};